var EventBlock = window.EventBlock = (function () {
    const selectors = {
        header: '[eb-header]',
        titleT1: '[oe-t1]',
        titleT2: '[oe-t2]',

        market: '.event-markets__item',
        cell: '.event-markets__coef',
        cellValue: '.event-markets__coef-value'
    };

    function animateCellChange(cellNode, isInc) {
        var className = (isInc) ? 'change plus' : 'change minus';

        cellNode.addClass(className);
        setTimeout(function () { cellNode.removeClass(className);}, 2000);
    }


    //ctor
    var EventBlock = function (wrapperNode, eType) {
        this.init(wrapperNode, eType);
    };

    var EType = {
        Undefined: 0,
        Accent: 10,
        OpenEvent: 20,
        LiveTable: 30
    };
    EventBlock.EType = EType;


    //WrapperNode DOM requirements:
    //data-event-id
    //data-islive
    //inner <div [eb-header] data-dscr="dscr" data-isTable="">
    //inner <div id="eb-list{id}" class="+m-blocked">
    EventBlock.prototype.init = function (wrapperNode, eType) {
        this.domNode = wrapperNode;
        this.setType(eType);

        this.bindUI();

        this.id = this.domNode.data('event-id');

        if (this.type === EType.LiveTable) {
            this.isLive = true;
            this.title = this.domNode.closest(ModeTableLive.selectors.event).find(ModeTableLive.selectors.eventTitle).first().text().trim();

            return;
        }

        this.isLive = Boolean(this.domNode.data('islive'));

        if (this.type === EType.OpenEvent) {
            this.loadState();
            this.restoreMarkets();
        }

        this.title = this.domNode.find(selectors.titleT1).text() + (this.domNode.find(selectors.titleT2).length ? ' — ' + this.domNode.find(selectors.titleT2).text() : '');
    };

    EventBlock.prototype.dispose = function () {
        this.unBindUI();
    };

    EventBlock.prototype.setType = function (eType) {
        if (eType === EType.Accent || eType === EType.OpenEvent || eType === EType.LiveTable) {
            this.type = eType;
        }
        else {
            this.type = EType.Undefined;
        }
    };

    EventBlock.prototype.bindUI = function () {
        var self = this;

        // Betting cart (add/remove)
        self.domNode.on('click', selectors.cell + '[data-aid]', function () {
            var that = $(this);

            if (that.hasClass('active')) {
                var oid = that.attr('data-oid');
                if (BettingCart.removeItem(oid)) // return false if cart is sending now, return true if removed or already removed.  Blink on false
                    that.removeClass('active');
            }
            else {
                var marketNode = that.closest(selectors.market);
                if (marketNode.hasClass('m-blocked'))
                    return;

                var sData = {
                    oId: that.attr('data-oid'),
                    aId: that.attr('data-aid'),
                    rTitle: marketNode.find('.event-markets__title').text() + ' (' + that.find('.event-markets__coef-title').attr('title') + ')',
                    val: that.find(selectors.cellValue).attr('data-coefvalue'),
                    eId: self.id,
                    eTitle: self.title,
                    isLive: self.isLive
                };

                if (BettingCart.addItem(sData)) {
                    that.addClass('active');
                    if (self.type === EType.LiveTable) {
                        BettingCart.Highlighting.activate.table();
                    }
                }

            }
            return false;
        });

        if (this.type === EType.OpenEvent) {
            self.domNode.on('click', selectors.market, function (e) {
                if (e.target.className === 'event-markets__body') {
                    return false;
                }

                var that = $(this);
                that.toggleClass('m-collapsed');
                self.setMarketState(that.attr('data-id'), !that.hasClass('m-collapsed'));
                return false;
            });
        }

    };
    EventBlock.prototype.unBindUI = function () {
        this.domNode
            .off('click', selectors.cell + '[data-aid]')
            .off('click', selectors.market);
    };

    //
    EventBlock.prototype.setMarketState = function (id, isExpanded) {
        this.state[id] = isExpanded;
        this.saveState();
    };
    EventBlock.prototype.loadState = function () {
        var jsonState = sessionStorage.getItem('event' + this.id);
        this.state = (jsonState === null) ? {} : JSON.parse(jsonState);
    };
    EventBlock.prototype.saveState = function () {
        sessionStorage.setItem('event' + this.id, JSON.stringify(this.state));
    };
    EventBlock.prototype.restoreMarkets = function () {
        var self = this;

        for (var key in self.state) {
            var marketNode = self.domNode.find(selectors.market + '[data-id=' + key + ']');
            (self.state[key] === true) ? marketNode.removeClass('m-collapsed') : marketNode.addClass('m-collapsed');
        }
    };

    EventBlock.prototype.oldResults = [];
    EventBlock.prototype.saveCurrentState = function () {
        var self = this;
        self.oldResults = [];
        self.domNode.find(selectors.cell + '[data-oid]').each(function (ind) {
            var oid = $(this).data('oid');
            var val = $(this).find(selectors.cellValue).attr('data-coefvalue');
            self.oldResults[oid] = val;
        });
    };


    return EventBlock;
}());